import { useMemo } from 'react';
import { IconButton, Row, Typography } from 'seagull';
import { WideArrowBackward } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { relationshipModel } from "../../../../../models";
import styles from "./MobileHeader.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetMobileHeaderTID = parentTestId => getTestIds({
  parentTestId
});
export const MobileHeader = _ref => {
  let {
    testId,
    relationship,
    showBack,
    onBack
  } = _ref;
  const {
    MobileHeaderTestIds
  } = useMemo(() => GetMobileHeaderTID(testId), [testId]);
  const vendorLogoUrl = relationshipModel.vendorLogoUrl({
    vendor: relationship.vendor
  });
  return /*#__PURE__*/_jsxs(Row, {
    className: styles.root,
    testId: MobileHeaderTestIds.Root(),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.backButtonSlot,
      children: showBack && onBack && /*#__PURE__*/_jsx(IconButton, {
        onClick: onBack,
        testId: MobileHeaderTestIds.BackButton(),
        children: /*#__PURE__*/_jsx(WideArrowBackward, {})
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.logoSlot,
      children: vendorLogoUrl ? /*#__PURE__*/_jsx("img", {
        src: vendorLogoUrl,
        alt: relationship.vendor.name,
        className: styles.vendorLogo,
        "data-testid": MobileHeaderTestIds.VendorLogo()
      }) : /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        weight: "normal",
        testId: MobileHeaderTestIds.VendorName(),
        children: relationship.vendor.name
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.spacer
    })]
  });
};